"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeismicCommonCore = void 0;
require("reflect-metadata");
var rxjs_1 = require("rxjs");
var typedi_1 = require("typedi");
var getService_1 = require("./util/getService");
var SeismicCommonCore = /** @class */ (function () {
    function SeismicCommonCore() {
        this.onTenantSetSubject = new rxjs_1.ReplaySubject();
        this.onTenantSet = this.onTenantSetSubject.asObservable();
        this.serviceAdded = new rxjs_1.ReplaySubject();
    }
    SeismicCommonCore.prototype.getService = function (type) {
        return (0, getService_1.getService)(type);
    };
    SeismicCommonCore.prototype.setService = function (name, type) {
        typedi_1.Container.set(name, type);
    };
    SeismicCommonCore.prototype.setSubdomain = function (tenant) {
        this.tenant = tenant;
        this.onTenantSetSubject.next(tenant);
    };
    SeismicCommonCore.prototype.getSubdomain = function () {
        if (!this.tenant) {
            console.warn('Calling SeismicCommon.getTenant before setTenant was called');
        }
        return this.tenant;
    };
    SeismicCommonCore.prototype.setClientId = function (clientId) {
        this.clientId = clientId;
    };
    SeismicCommonCore.prototype.getClientId = function () {
        return this.clientId;
    };
    return SeismicCommonCore;
}());
exports.SeismicCommonCore = SeismicCommonCore;
//# sourceMappingURL=SeismicCommonCore.js.map